<!-- 周销售报表 -->
<template>
    <div id="home">
    	<van-nav-bar
		  	:title="$t('WeekReport.title')"
			left-arrow
			fixed
			:right-text="$t('DayReport.export')"
		  	@click-right="onClickExport"
		  	@click-left="$router.push('/ShopSet/'+sessionStorage.actShopId)">
		</van-nav-bar>
		<div class="chartBox" id="chart"></div>
		<van-cell-group>
			<van-cell>
				<van-row>
			  		<!-- <van-col span="6">{{$t('WeekReport.weeks')}}</van-col>
			  		<van-col span="12">{{$t('WeekReport.peoopleNum')}}</van-col>
			  		<van-col span="6">{{$t('WeekReport.amountOfMoney')}}({{currency}})</van-col> -->
			  		<!-- <van-col span="3">{{$t('WeekReport.weeks')}}</van-col> -->
			  		<van-col span="5">{{$t('WeekReport.weekday')}}</van-col>
			  		<van-col span="3">{{$t('WeekReport.peoopleNum')}}</van-col>
			  		<van-col span="3">Line Pay</van-col>
			  		<van-col span="3">{{$t('payMethod.card')}}</van-col>
			  		<van-col span="3">{{$t('payMethod.cash')}}</van-col>
			  		<van-col span="3">{{$t('payMethod.other')}}</van-col>
			  		<van-col span="4">{{$t('payMethod.totalprice')}} ({{currency}})</van-col>
				</van-row>
				<div slot="right-icon" style="width: 22px;"></div>
			</van-cell>
			<template v-for="(item,index) in weekData">
				<van-cell center is-link :to="{ path: '/WeekDetail',query:{week:item.period,startday:item.startday,endday:item.endday}}">
					<van-row>
						<!-- <van-col span="3">{{item.period}}</van-col> -->
						<van-col span="5">{{item.start}}~{{item.end}}</van-col>
				  		<van-col span="3">{{item.number}}</van-col>
				  		<van-col span="3">{{item.line_pay}}</van-col>
				  		<van-col span="3">{{item.card}}</van-col>
				  		<van-col span="3">{{item.price}}</van-col>
				  		<van-col span="3">{{item.other}}</van-col>
				  		<van-col span="4">{{item.total}}</van-col>
					</van-row>
				</van-cell>
			</template>
		</van-cell-group>
    </div>
</template>
<script>
  	export default {
  		data () {
	      	return {
	      		options:{
	      			title: {
				        text: this.$t('WeekReport.title')
				    },
				    color: ['red'],
				    tooltip: {},
					// toolbox: {
     //                    feature: {
     //                        saveAsImage: {
     //                        }
     //                    }
     //                },
				    xAxis: {
				    	name:this.$t('WeekReport.weeks'),
				        data: ['1', '2', '3', '4', '5', '6','7'],
				    	axisTick: {
			                alignWithLabel: true,
			            },
			            axisLabel:{
			                interval:0
			            }
				    },
				    yAxis: {
				    	name:this.$t('WeekReport.money'),
				    },
				    grid: {
                        left: '5%',
                        // right: '4%',
                        bottom: '10%',
                        containLabel: true
                    },
				    series: [{
				        name: this.$t('WeekReport.amountOfMoney'),
				        type: 'bar',
				        label: {
			                normal: {
			                    show: true,
			                    position: 'top'
			                }
	            		},
				        data: [10, 20, 15, 30, 40, 10,5],
				    }]
	      		},
	      		weekData:[],
	      		weekChart:'',
				nowDate:(Math.round(new Date().getTime()/1000)),
				currency:''
	      	}
	    },
	    mounted:function(){
	    	this.weekChart=this.$echarts.init(document.getElementById("chart"));
	    	this.getWeekData();
			console.log(this.nowDate);
			this.getCurrency()
	    },
	    methods:{
	    	// 获取周报表
	    	getWeekData(){
				this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/totalWeekIncome',
	                data:{
	                	date:this.nowDate,
	                }
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	            		var weekList = [];
	            		res.data.data.forEach((item,index) => {
	            			item.start = item.startday.split('-').join('/');
	            			item.end = item.endday.split('-').join('/');
	            			weekList.push(item);
	            		})
	                	this.weekData=weekList;
	                	this.options.xAxis.data=res.data.week;
	                	this.options.series[0].data=res.data.price;
	    				this.weekChartInit();
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
	    	weekChartInit(){
	    		this.weekChart.setOption(this.options);
			},
			// 获取店铺设置的货币
			getCurrency(){
				this.$axios({
	                method: 'get',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/currency',
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
						this.currency = res.data.data.unit
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('EditDish.message'),
	        		});
	            });
			},
			// 导出报表
			onClickExport(){
				window.location.href = this.$build+'/api/store/'+sessionStorage.actShopId+'/exportReport?param=totalWeekIncome&date='+this.nowDate;
			}
	  	}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell__left-icon, .van-cell__right-icon{
		font-size: 22px;
	}
	/deep/ .van-nav-bar__right .van-nav-bar__text{color: #fff;}
	.chartBox{
		width: 100%;
		min-height: 240px;
		background-color: #fff;
		padding-top: 10px;
	}
	.content{
		color: #000;
	}
	.title{
		font-size: 14px;
		color: #444;
	}
</style>


// WEBPACK FOOTER //
// src/Report/WeekReport.vue